import {
    ArtikelApiDto,
    BenutzerDetailApiDto,
    BenutzerInfoSearchResultApiDto,
    DokumentApiDto,
    LieferantDetailApiDto,
    TakeTeilnehmerApiDto,
    TeilnehmerListApiDto,
    TvsLieferantFehlerhafteRechnungApiDto,
    VetdataVerarbeitungLogApiDto
} from '@/api-schema';
import { ArtikelFilterDto } from '@/types/ArtikelFilterDto';
import { BenutzerInfoSearchApiDto } from '@/types/BenutzerInfoSearchApiDto';
import { TeilnehmerFilterDto } from '@/types/TeilnehmerFilterDto';
import { LieferantenDokumentFilterDto } from '@/types/LieferantenDokumentFilterDto';
import { RechnungFilterDto } from '@/types/RechnungFilterDto';

export interface IAdministrationState {
    teilnehmer: TakeTeilnehmerApiDto;
    teilnehmerFilter: TeilnehmerFilterDto;
    lieferantenDokumentFilter: LieferantenDokumentFilterDto;
    teilnehmerList: Array<TeilnehmerListApiDto>;
    teilnehmerTotalNumberOfRecords: number | null;
    teilnehmerLoading: boolean;
    artikelLoading: boolean;
    artikelTotalNumberOfRecords: number | null;
    artikelQueryFilter: ArtikelFilterDto;
    artikelList: Array<ArtikelApiDto>;
    vetdataLog: VetdataVerarbeitungLogApiDto;
    benutzerFilter: BenutzerInfoSearchApiDto;
    benutzerInfoSearchResultApiDtoList: Array<BenutzerInfoSearchResultApiDto>;
    benutzerTotalNumberOfRecords: number | null;
    benutzerLoading: boolean;
    lieferantDetails: LieferantDetailApiDto;
    lieferantenDokumentList: Array<DokumentApiDto>;
    lieferantenDokumenteTotalNumberOfRecords: number | null;
    dokumenteLoading: boolean;
    lieferantenListe: Array<object>;
    fehlerhafteRechnungenList: Array<TvsLieferantFehlerhafteRechnungApiDto>;
    fehlerhafteRechnungenTotalNumberOfRecords: number | null;
    fehlerhafteRechnungenLoading: boolean;
    fehlerhafteRechnungenFilter: RechnungFilterDto;
    fehlerhafteRechnungenOffset: number;
    benutzerDetails: BenutzerDetailApiDto;
}

export const state: IAdministrationState = {
    teilnehmer: {
        teilnehmerId: null,
        tvsKundennummer: null,
        benutzerRolle: ''
    },
    teilnehmerFilter: new TeilnehmerFilterDto(),
    lieferantenDokumentFilter: new LieferantenDokumentFilterDto(),
    teilnehmerList: [],
    teilnehmerTotalNumberOfRecords: null,
    teilnehmerLoading: false,
    artikelLoading: false,
    artikelTotalNumberOfRecords: null,
    artikelQueryFilter: new ArtikelFilterDto(),
    artikelList: [],
    vetdataLog: {},
    benutzerFilter: new BenutzerInfoSearchApiDto(),
    benutzerInfoSearchResultApiDtoList: [],
    benutzerTotalNumberOfRecords: null,
    benutzerLoading: false,
    lieferantDetails: null,
    lieferantenDokumentList: [],
    lieferantenDokumenteTotalNumberOfRecords: null,
    dokumenteLoading: false,
    lieferantenListe: [],
    fehlerhafteRechnungenList: [],
    fehlerhafteRechnungenTotalNumberOfRecords: null,
    fehlerhafteRechnungenLoading: false,
    fehlerhafteRechnungenFilter: new RechnungFilterDto(),
    fehlerhafteRechnungenOffset: 0,
    benutzerDetails: new Object()
};
